import React, { useContext } from "react"
import { Flex, Text, FilterCheckbox } from "@capioweb/ui-components"
import { CareerFilterContext } from "../context/CareerFilterContext"

interface FilterSectionProps {
	filterType: "county" | "jobType" | "employmentType"
	heading?: string
	filterValues: CareerFilterValue[]
	lastChild?: boolean
}

export const FilterSection: React.FC<FilterSectionProps> = ({
	filterType,
	heading = "",
	filterValues,
	lastChild = false,
}) => {
	const {
		activeCountyIds,
		activeJobTypeIds,
		activeEmploymentTypeIds,
		toggleActiveCounty,
		toggleActiveJobType,
		toggleActiveEmploymentType,
	} = useContext(CareerFilterContext)

	return (
		<>
			<Flex
				w={1}
				flexDirection="column"
				pb={1.5}
				mb={{ _: 0, l: lastChild ? 2 : 3 }}
				borderBottom={lastChild ? false : { _: false, l: true }}
			>
				{heading && (
					<Text
						fontSize={1.75}
						lineHeight={2.5}
						fontWeight="bold"
						letterSpacing="1px"
						textTransform="uppercase"
						mb={1.5}
					>
						{heading}
					</Text>
				)}
				<Flex w={1} flexWrap="wrap">
					{filterValues.map((filter) => {
						return (
							<Flex pb={1.5} pr={1.5} key={filter.id}>
								{filterType === "county" && (
									<FilterCheckbox
										checked={activeCountyIds.includes(filter.id)}
										label={filter.name}
										value={filter.name.toString()}
										onChange={() => {
											toggleActiveCounty(filter.id)
										}}
										withoutBorder={true}
									/>
								)}
								{filterType === "jobType" && (
									<FilterCheckbox
										checked={activeJobTypeIds.includes(filter.id)}
										label={filter.name}
										value={filter.name.toString()}
										onChange={() => {
											toggleActiveJobType(filter.id)
										}}
										withoutBorder={true}
									/>
								)}
								{filterType === "employmentType" && (
									<FilterCheckbox
										checked={activeEmploymentTypeIds.includes(filter.id)}
										label={filter.name}
										value={filter.name.toString()}
										onChange={() => {
											toggleActiveEmploymentType(filter.id)
										}}
										withoutBorder={true}
									/>
								)}
							</Flex>
						)
					})}
				</Flex>
			</Flex>
		</>
	)
}
